import { render, staticRenderFns } from "./WebServer.vue?vue&type=template&id=51796f86&scoped=true&"
import script from "./WebServer.vue?vue&type=script&lang=js&"
export * from "./WebServer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51796f86",
  null
  
)

export default component.exports